import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Textarea
} from '@clientbase/clientbase-library'
import { yupResolver } from '@hookform/resolvers/yup'
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material'
import { DataService } from 'api/DataService'
import { notifyAccountAlertsChanged } from 'features/AccountAlerts/utils/dismissedAlerts'
import { parseCookies, setCookie } from 'nookies'
import * as yup from 'yup'

import { SESSION_COOKIE_OPTIONS } from 'utils/sessionCookie'

import { theme } from 'styles/theme'

import * as S from './styles'

interface NPSForm {
  score: number | null
  benefits: string
  suggestions: string
}

const schemaForm = yup.object({
  score: yup.number(),
  benefits: yup.string(),
  suggestions: yup.string()
})

interface ModalSurveyNPSProps {
  open?: boolean
  onClose?: () => void
}

const ModalSurveyNPS = ({ open, onClose }: ModalSurveyNPSProps = {}) => {
  const { control, watch } = useForm<NPSForm>({
    defaultValues: {
      score: undefined,
      benefits: '',
      suggestions: ''
    },
    resolver: yupResolver(schemaForm)
  })

  const { score, benefits, suggestions } = watch()

  const isControlled = open !== undefined
  const [internalOpen, setInternalOpen] = useState(true)
  const isOpenModalSurvey = isControlled ? open : internalOpen

  const { ['nextauth.merchant_user_uuid']: merchant_user_uuid } = parseCookies()
  const { ['nextauth.merchant_user_name']: userName } = parseCookies()
  const handleClick = async () => {
    if (score == null || !benefits.length || !suggestions.length) {
      toast.error('Você precisa preencher todos os campos.')
    } else {
      const response = await DataService({
        data: {
          score,
          benefits,
          suggestions,
          merchant_user_uuid
        },
        type: 'POST',
        url: '/v1/nps_answers'
      })
      if (response?.error) {
        toast.error('Houve um erro ao enviar a avaliação')
        return
      }
      setCookie(undefined, 'nextauth.show_nps', 'false', SESSION_COOKIE_OPTIONS)
      // SC-11817: tira o aviso da pesquisa do banner na hora.
      notifyAccountAlertsChanged()
      toast.success('Obrigado! Agradecemos a sua resposta 😃')
      if (isControlled) {
        onClose?.()
      } else {
        setInternalOpen(false)
      }
    }
  }

  const handleCloseSurvey = () => {
    if (isControlled) {
      onClose?.()
    } else {
      setInternalOpen(false)
    }
  }

  return (
    <>
      <Modal
        width={'auto + 0%'}
        height={'auto !important'}
        handleClose={handleCloseSurvey}
        open={isOpenModalSurvey}
        size="large"
      >
        <ModalBody>
          <ModalHeader onClose={handleCloseSurvey} sx={{ border: 'none' }}>
            <Typography variant="lgBold">Olá, {userName}</Typography>
          </ModalHeader>

          <ModalContent>
            <S.Wrapper>
              <Box display="flex" flexDirection="column">
                <Box
                  display={'flex'}
                  flexWrap={'wrap'}
                  flexDirection={'column'}
                  gap={2}
                  mt={0}
                >
                  <Typography>
                    {' '}
                    Desenvolvemos esta pesquisa de satisfação para entender
                    melhor como podemos continuar evoluindo nossos serviços para
                    você.
                  </Typography>
                  <Typography>
                    Você consegue nos ajudar respondendo abaixo, por favor? 😊{' '}
                    Obrigado!
                  </Typography>
                </Box>
              </Box>

              <Typography variant="smBold" mb={-1}>
                Como você se sentiria se não pudesse mais usar a Base de
                Clientes?
              </Typography>

              <Controller
                control={control}
                name="score"
                render={({ field }) => (
                  <RadioGroup {...field}>
                    <FormControlLabel
                      value={0}
                      control={<Radio />}
                      label={
                        <Typography color={theme.palette.neutral[400]}>
                          Ficaria muito desapontado
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label={
                        <Typography color={theme.palette.neutral[400]}>
                          Ficaria um pouco desapontado
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label={
                        <Typography color={theme.palette.neutral[400]}>
                          Não ficaria desapontado
                        </Typography>
                      }
                    />
                  </RadioGroup>
                )}
              />

              <Typography variant="smBold">
                Qual é o maior benefício que você tem com a Base de Clientes?
              </Typography>

              <Controller
                control={control}
                name="benefits"
                render={({ field }) => (
                  <Textarea
                    fullWidth={false}
                    placeholder="Insira sua resposta..."
                    maxLength={2000}
                    height="60px"
                    {...field}
                  />
                )}
              />

              <Typography variant="smBold">
                Como podemos melhorar a Base de Clientes para você?
              </Typography>

              <Controller
                control={control}
                name="suggestions"
                render={({ field }) => (
                  <Textarea
                    fullWidth={false}
                    placeholder="Insira sua resposta..."
                    maxLength={2000}
                    height="60px"
                    {...field}
                  />
                )}
              />
            </S.Wrapper>
          </ModalContent>

          <ModalFooter>
            <Button
              variantButton="primary"
              buttonSize="lg"
              onClick={handleClick}
            >
              Enviar resposta
            </Button>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </>
  )
}
export default ModalSurveyNPS
